__turbopack_context__.v({
  "content": "styles-module-scss-module__Ygkdta__content",
  "root": "styles-module-scss-module__Ygkdta__root",
});
